import { OnInit, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';
import { ListComponent } from '../list/list.component';
import { ServiceBase } from '../../interfaces/service-base.interface';
import { ListFilterOperator } from '../../enums/list-filter-operator.enum';
import { ListObject } from '../../models/list-object.model';
import { CoreService } from '../../services/core.service';

export abstract class ImplementedListComponent<T extends { id: number }> extends ListComponent<T>
  implements OnInit, OnDestroy {
  public filterOp = ListFilterOperator;

  constructor(protected readonly coreService: CoreService, protected readonly service: ServiceBase<T>) {
    super(coreService);
  }

  public getList(): Observable<ListObject<T>> {
    return this.service.getAll(this.parameters);
  }

  public delete(item: T) {
    this.startLoading();
    this.service.delete(item.id).subscribe(() => this.loadList(), () => this.stopLoading());
  }

  public ngOnInit(): void {
    super.ngOnInit();
  }

  public ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
